import { render, staticRenderFns } from "./CursorPagination.vue?vue&type=template&id=7365158e&"
import script from "./CursorPagination.vue?vue&type=script&lang=js&"
export * from "./CursorPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports